const BaseView = require('./view');

module.exports = BaseView.extend({
    events: Odigeo._.merge({
        'tap .baggage_selectable_item': 'onSelectBaggage',
        'tap .baggage_remove': 'onBaggageRemove',
    }, BaseView.prototype.events),
});
